const initialState = {
  files: [],
  page: 1,
  filtersFormState: {
    data: {}
  },
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'SET_FILES': {
      const { files, page } = payload;
      return {
        ...state,
        files,
        page,
      };
    }
    case 'FILE_FILTERS_CHANGE': {
      const { filtersFormState } = payload;
      return {
        ...state,
        filtersFormState,
        page: 1,
      };
    }
    case 'FILES_NEXT_PAGE': {
      const page = Number(state.page);
      return {
        ...state,
        page: page + 1,
      };
    }
    case 'FILES_PREVIOUS_PAGE': {
      const page = Number(state.page);
      return {
        ...state,
        page: page > 1 ? page - 1 : 1,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Files/Files.reducer.js